import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
/**
* @public
*/
const SearchIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsx("svg", {
		"data-sanity-icon": "search",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: /* @__PURE__ */ jsx("path", {
			d: "M15.0355 15.0355L20 20M16.5 11.5C16.5 14.2614 14.2614 16.5 11.5 16.5C8.73858 16.5 6.5 14.2614 6.5 11.5C6.5 8.73858 8.73858 6.5 11.5 6.5C14.2614 6.5 16.5 8.73858 16.5 11.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinejoin: "round"
		})
	});
});
export { SearchIcon, SearchIcon as default };

//# sourceMappingURL=Search.js.map